import React, { useState, useMemo } from "react";
import { useQuery } from "react-query";

import {
  //
  Divider as MuiDivider,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import styled from "styled-components/macro";

import Table from "../../components/Table";
import { spacing } from "@material-ui/system";
import Panel from "../../components/panels/Panel";

import { Helmet } from "react-helmet-async";
import Loader from "../../components/Loader";
import { dateFormatter } from "../../utils";
import axios from "axios";

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
  max-height: calc(100% - 48px);
`;

const Divider = styled(MuiDivider)(spacing);

//388px
const SitesSummaryTable = () => {
  const [showCCBWQA, setShowCCBWQA] = useState(true);
  const [showOther, setShowOther] = useState(false);
  const { data, isFetching, error } = useQuery(
    ["/api/locations-param-summary"],
    async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/locations-param-summary`
        );

        return data;
      } catch (err) {
        console.error(err);
      }
    },
    { keepPreviousData: true, refetchOnWindowFocus: false }
  );

  // Sort and filter data
  const processedData = useMemo(() => {
    if (!data) return [];

    let filteredData = data.filter((item) => {
      if (item.is_ccbwqa && showCCBWQA) return true;
      if (!item.is_ccbwqa && showOther) return true;
      return false;
    });

    // Sort to put CCBWQA sites at the top
    return filteredData.sort((a, b) => {
      // First sort by is_ccbwqa (true comes before false)
      if (a.is_ccbwqa && !b.is_ccbwqa) return -1;
      if (!a.is_ccbwqa && b.is_ccbwqa) return 1;
      // Then sort by location name
      return (a.location_descrip ?? "").localeCompare(b.location_descrip ?? "");
    });
  }, [data, showCCBWQA, showOther]);

  if (error) return "An error has occurred: " + error.message;

  const tabColumns = [
    {
      title: "Data Source",
      field: "is_ccbwqa",
      render: (rowData) => {
        return rowData.is_ccbwqa ? "CCBWQA" : "Other";
      },
    },
    {
      title: "Location Name",
      field: "location_descrip",
    },
    {
      title: "Location Type",
      field: "location_type",
    },
    {
      title: "Parameter",
      field: "param_descrip",
    },
    {
      title: "Parameter Group",
      field: "param_group",
    },
    {
      title: "HUC8",
      field: "huc_8",
    },
    {
      title: "Starting Period of Record",
      field: "start_por",
      render: (rowData) => {
        return dateFormatter(rowData.por_start, "MM/DD/YYYY");
      },
    },
    {
      title: "Ending Period of Record",
      field: "end_por",
      render: (rowData) => {
        return dateFormatter(rowData.por_end, "MM/DD/YYYY");
      },
    },
    {
      title: "Years",
      field: "years",
    },
    {
      title: "Latitude",
      field: "loc_lat",
    },
    {
      title: "Longitude",
      field: "loc_lon",
    },
  ];

  return (
    <>
      <Helmet title="Site Summary Table" />
      <Typography variant="h3" component="h1" gutterBottom display="inline">
        Site Summary Table
      </Typography>

      {/**/}
      {/*  <Link component={NavLink} exact to="/dashboard">*/}
      {/*    Dashboard*/}
      {/*  </Link>*/}
      {/*  <Typography>Site Summary Table</Typography>*/}
      {/**/}

      <Divider my={6} />

      <Alert severity="info" style={{ marginBottom: 16 }}>
        <Box>
          <Typography variant="body2" gutterBottom>
            By default, only CCBWQA monitoring locations are displayed. Use the
            checkboxes below to also include public data sources.
          </Typography>
          <Box display="flex" alignItems="center" mt={1}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCCBWQA}
                  onChange={(e) => setShowCCBWQA(e.target.checked)}
                  color="primary"
                />
              }
              label="CCBWQA Locations"
              style={{ marginRight: 24 }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={showOther}
                  onChange={(e) => setShowOther(e.target.checked)}
                  color="primary"
                />
              }
              label="Other Public Locations"
            />
          </Box>
        </Box>
      </Alert>
      <Panel>
        <TableWrapper>
          {data ? (
            <Table
              label="Site Summary Table"
              isLoading={isFetching}
              columns={tabColumns}
              data={processedData}
              height="calc(100vh - 64px - 48px - 106px - 48px - 64px - 156px)"
              pageSize={60}
            />
          ) : (
            <Loader />
          )}
        </TableWrapper>
      </Panel>
    </>
  );
};

export default SitesSummaryTable;
